import type { SocialPostMedia } from '@nucleus-commerce/api-client/admin';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import { MediaThumb, useMedia } from '@/features/media';

/**
 * The post's first image: the 2:3 rendition once rendered, else the library file it came from.
 * A post without images shows the empty placeholder.
 */
export function PostThumb({
  media,
  className,
}: {
  media: SocialPostMedia | undefined;
  className?: string;
}) {
  const { data } = useMedia(media && !media.url ? media.mediaId : null);
  if (media?.url) {
    return (
      <div
        className={cn(
          'bg-muted flex aspect-square items-center justify-center overflow-hidden rounded-md',
          className,
        )}
      >
        <img src={media.url} alt="" className="size-full object-cover" loading="lazy" />
      </div>
    );
  }
  return <MediaThumb media={media ? data : null} className={className} />;
}
